/* Nextmac: "Andere configuraties" + live specificaties (werkgeheugen/opslag).
   Volgt de keuze in het keuzemenu: direct bij een klik (uit de product-JSON) en na Dawn's variantwissel. */
(function () {
  if (window.nmSecties) return;
  window.nmSecties = true;

  var PIJL_OP = '<svg viewBox="0 0 16 16" width="14" height="14" fill="none" aria-hidden="true"><path d="M3.5 9.5L8 5l4.5 4.5M3.5 13L8 8.5l4.5 4.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function geld(cents, format) {
    format = format || '€{{amount_with_comma_separator}}';
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var soort = m ? m[1] : 'amount';
    function num(n, dec, duizend, komma) {
      var s = (Math.abs(n) / 100).toFixed(dec).split('.');
      s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, duizend);
      return s[1] ? s[0] + komma + s[1] : s[0];
    }
    var uit;
    switch (soort) {
      case 'amount_no_decimals': uit = num(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': uit = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': uit = num(cents, 0, '.', ','); break;
      default: uit = num(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, uit);
  }
  function kort(cents, format) { return geld(cents, format).replace(/[.,]00(?!\d)/, ''); }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function afbeelding(src, breedte) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + breedte;
  }

  /* ---------- Product-JSON ---------- */
  function laad(url, klaar) {
    var c = (window.nmProductCache = window.nmProductCache || {});
    if (c[url] && c[url].variants) return klaar(c[url]);
    fetch(url + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) { c[url] = p; klaar(p); })
      .catch(function () {});
  }
  function menu() { return document.querySelector('variant-selects.nm-km[data-nm-km-main]'); }
  function gekozenOpties() {
    var vs = menu();
    if (!vs) return null;
    return [].map.call(vs.querySelectorAll('fieldset'), function (f) {
      var k = f.querySelector('input[type=radio]:checked');
      return k ? k.value : null;
    });
  }
  function vindVariant(p, opties) {
    if (!opties) return null;
    for (var i = 0; i < p.variants.length; i++) {
      var v = p.variants[i], ok = true;
      for (var j = 0; j < v.options.length; j++) if (v.options[j] !== opties[j]) { ok = false; break; }
      if (ok) return v;
    }
    return null;
  }

  /* ---------- Specificaties live ---------- */
  function specs(v) {
    if (!v) return;
    [].forEach.call(document.querySelectorAll('[data-nm-spec-index]'), function (el) {
      var i = parseInt(el.dataset.nmSpecIndex, 10);
      if (v.options[i] != null) el.textContent = v.options[i] + (el.dataset.suffix || '');
    });
  }

  /* ---------- Andere configuraties ---------- */
  function rangen(p) {
    // volgorde van waarden zoals ze in de varianten voorkomen = volgorde in Shopify (Goed < Uitstekend < Premium, 8 < 16 GB, ...)
    var r = [];
    p.variants.forEach(function (v) {
      v.options.forEach(function (o, i) {
        r[i] = r[i] || [];
        if (r[i].indexOf(o) === -1) r[i].push(o);
      });
    });
    return r;
  }
  function ramIndex(p) {
    var namen = (p.options || []).map(function (o) { return (typeof o === 'string' ? o : o.name || '').toLowerCase(); });
    return namen.indexOf('ram');
  }
  function tekenConfiguraties(p, huidig) {
    var box = document.querySelector('[data-nm-conf]');
    if (!box || !huidig) return;
    var lijst = box.querySelector('[data-nm-conf-lijst]');
    var fmt = box.dataset.moneyFormat;
    var r = rangen(p), ri = ramIndex(p);

    var andere = p.variants.filter(function (v) { return v.available && v.id !== huidig.id; });
    andere.sort(function (a, b) {
      var da = 0, db = 0;
      a.options.forEach(function (o, i) { if (o !== huidig.options[i]) da++; });
      b.options.forEach(function (o, i) { if (o !== huidig.options[i]) db++; });
      if (da !== db) return da - db;
      return a.price - b.price;
    });
    var kaarten = [huidig].concat(andere.slice(0, 11));
    if (andere.length === 0) { box.hidden = true; return; }
    box.hidden = false;

    var standaardBeeld = p.featured_image;
    lijst.innerHTML = kaarten.map(function (v) {
      var isHuidig = v.id === huidig.id;
      var beeld = (v.featured_image && v.featured_image.src) || standaardBeeld;
      var regels = v.options.map(function (o, i) {
        var beter = !isHuidig && r[i].indexOf(o) > r[i].indexOf(huidig.options[i]);
        var anders = !isHuidig && o !== huidig.options[i];
        return '<span class="nm-conf__regel' + (beter ? ' is-beter' : anders ? ' is-anders' : '') + '">' +
          (beter ? PIJL_OP : '') + esc(o) + (i === ri ? ' RAM' : '') + '</span>';
      }).join('');
      var d = v.price - huidig.price;
      var verschil = isHuidig ? '<span class="nm-conf__verschil is-huidig">Jouw keuze</span>'
        : '<span class="nm-conf__verschil">' + (d < 0 ? '− ' : '+ ') + esc(kort(d, fmt)) + '</span>';
      return '<button type="button" class="nm-conf__kaart' + (isHuidig ? ' is-huidig' : '') + '" data-id="' + v.id + '"' +
        (isHuidig ? ' aria-current="true"' : '') + '>' +
        (beeld ? '<span class="nm-conf__beeld"><img src="' + esc(afbeelding(beeld, 240)) + '" alt="" loading="lazy" width="120" height="120"></span>' : '') +
        '<span class="nm-conf__regels">' + regels + '</span>' +
        '<span class="nm-conf__voet"><span class="nm-conf__prijs">' + esc(geld(v.price, fmt)) + '</span>' + verschil + '</span>' +
        '</button>';
    }).join('');
    lijst.scrollLeft = 0;
    navStatus();
  }

  function kies(p, id) {
    var v = p.variants.filter(function (x) { return x.id === id; })[0];
    var vs = menu();
    if (!v || !vs) return;
    var groepen = vs.querySelectorAll('fieldset'), laatste = null;
    [].forEach.call(groepen, function (g, i) {
      [].forEach.call(g.querySelectorAll('input[type=radio]'), function (r) {
        if (r.value === v.options[i]) {
          if (!r.checked) laatste = r;
          r.disabled = false;
          r.checked = true;
        }
      });
    });
    if (laatste) laatste.dispatchEvent(new Event('change', { bubbles: true }));
    // terug naar het keuzemenu, zodat de klant de wijziging ziet
    var pi = vs.closest('product-info') || vs;
    var kop = document.querySelector('.section-header');
    var y = pi.getBoundingClientRect().top + window.pageYOffset - (kop ? kop.offsetHeight : 0) - 16;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }

  function navStatus() {
    var box = document.querySelector('[data-nm-conf]');
    if (!box) return;
    var l = box.querySelector('[data-nm-conf-lijst]');
    var v = box.querySelector('[data-nm-conf-vorige]'), n = box.querySelector('[data-nm-conf-volgende]');
    var past = l.scrollWidth <= l.clientWidth + 4;
    box.classList.toggle('past', past);
    if (v) v.disabled = l.scrollLeft <= 4;
    if (n) n.disabled = l.scrollLeft + l.clientWidth >= l.scrollWidth - 4;
  }

  /* ---------- Bijwerken ---------- */
  var product = null;
  function bijwerken(variant) {
    if (!product) return;
    var v = variant || vindVariant(product, gekozenOpties());
    if (!v) return;
    specs(v);
    tekenConfiguraties(product, v);
  }

  function start() {
    var box = document.querySelector('[data-nm-conf]');
    var pi = document.querySelector('product-info[data-url]');
    var url = (box && box.dataset.url) || (pi && pi.dataset.url);
    if (!url || !document.querySelector('[data-nm-conf], [data-nm-specs]')) return;
    laad(url, function (p) {
      product = p;
      bijwerken();
    });

    if (box) {
      var lijst = box.querySelector('[data-nm-conf-lijst]');
      box.addEventListener('click', function (e) {
        var kaart = e.target.closest('.nm-conf__kaart');
        if (kaart && product && !kaart.classList.contains('is-huidig')) kies(product, parseInt(kaart.dataset.id, 10));
        var stap = lijst.clientWidth * 0.8;
        if (e.target.closest('[data-nm-conf-vorige]')) lijst.scrollBy({ left: -stap, behavior: 'smooth' });
        if (e.target.closest('[data-nm-conf-volgende]')) lijst.scrollBy({ left: stap, behavior: 'smooth' });
      });
      var wacht = false;
      lijst.addEventListener('scroll', function () {
        if (wacht) return;
        wacht = true;
        requestAnimationFrame(function () { wacht = false; navStatus(); });
      }, { passive: true });
      window.addEventListener('resize', navStatus);
    }

    // Direct na een klik in het keuzemenu (na het auto-bijsturen van Nextmac)
    document.addEventListener('change', function (e) {
      if (!e.target || !e.target.closest || !e.target.closest('variant-selects.nm-km')) return;
      setTimeout(function () { bijwerken(); }, 0);
    });
    // En na Dawn's variantwissel (server-versie)
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
        var v = e && e.data && e.data.variant;
        if (v && product) bijwerken(product.variants.filter(function (x) { return x.id === v.id; })[0] || null);
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
